import { useState } from "react";
import { api, errText } from "@/lib/api";
import { MediaSlot } from "@/components/admin/MediaSlot";
import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

// Before / After looping clips shown at the very top of every customer quote page.
export const ShowcaseManager = ({ settings }) => {
  const [enabled, setEnabled] = useState(settings.showcase_enabled !== false);
  const [before, setBefore] = useState(settings.showcase_before || null);
  const [after, setAfter] = useState(settings.showcase_after || null);

  const toggle = async (v) => {
    setEnabled(v);
    try {
      await api.put("/settings", { showcase_enabled: v });
      toast.success(v ? "Showcase videos are live on customer quotes" : "Showcase videos hidden");
    } catch (e) {
      setEnabled(!v);
      toast.error(errText(e));
    }
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-3">
        <Switch data-testid="showcase-enabled-switch" checked={enabled} onCheckedChange={toggle} />
        <Label className="text-sm">Show the Before / After clips at the top of every customer quote</Label>
      </div>
      <div className="grid md:grid-cols-2 gap-5">
        <MediaSlot slot="showcase_before" label="Before video" hint="Plays silently on a loop. Short clip (15–60s), MP4 recommended." value={before} onChange={setBefore} />
        <MediaSlot slot="showcase_after" label="After video" hint="Same piece after Revival — shown right beside the Before clip." value={after} onChange={setAfter} />
      </div>
      <p className="text-xs text-gray-400 leading-relaxed">
        Uploaded clips are stored on ARK's storage and streamed from this app. If you paste a YouTube or Vimeo link it will
        autoplay muted, but their players can show branding — a direct upload gives the cleanest look.
      </p>
    </div>
  );
};
